import React, { Component } from "react";
import styled from "styled-components";
import { push } from "connected-react-router";
import { connect } from "react-redux";

import appUrls from "../../config/appUrls";

import background from "../../assets/images/login-background.png";
import logo from "../../assets/images/logo-login.png";

import Button from "../../components/Button";
import TextField from "../../components/TextField";

const Wrapper = styled.section`
  width: 100%;
  min-height: 100vh;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoginContainer = styled.div`
  width: 457.66px;
  height: 515px;
  background-color: rgba(9, 26, 45, 0.7);
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 575px) {
    width: 90%;
  }
`;

const LoginButton = styled(Button)`
  background: #455ee5;
  color: #fff;
  border: none;
  width: 130px;
  height: 33px;
  font-family: "dubai-bold";
  margin-top: 12%;
  font-size: 12px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 75%;
  height: 60%;
`;

const Link = styled.a`
  margin-top: 10px;
  font-size: 12px;
`;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Wrapper>
        <LoginContainer>
          <img src={logo} alt="logo" />
          <Form>
            <TextField
              type="text"
              placeholder="اسم  المستخدم او البريد الإلكتروني"
            />
            <TextField type="text" placeholder="كلمة المرور" />
            <LoginButton onClick={() => this.props.push(appUrls.HOME)}>
              تسجيل الدخول
            </LoginButton>
            <Link>نسيت كلمة المرور</Link>
          </Form>
        </LoginContainer>
      </Wrapper>
    );
  }
}
export default connect(
  null,
  { push }
)(Login);
